var _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLatestRepaymentsActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1989 17.1754L15.7889 15.7654C17.1063 14.4968 17.9492 12.8153 18.1773 11.0008C18.4054 9.18624 18.005 7.34834 17.0427 5.79321C16.0803 4.23807 14.6143 3.05959 12.8887 2.45407C11.163 1.84854 9.28201 1.85253 7.55896 2.46537L6.91895 0.565378C9.06934 -0.190153 11.4133 -0.188407 13.5626 0.570322C15.7118 1.32905 17.5374 2.79923 18.7369 4.73733C19.9364 6.67543 20.4378 8.96515 20.1581 11.2272C19.8784 13.4892 18.8344 15.5878 17.1989 17.1754Z",
    fill: "url(#paint0_linear_3151_4905)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0788 20.0355C8.08597 20.0512 6.13391 19.4711 4.47305 18.3697C2.81219 17.2682 1.51833 15.6956 0.757474 13.8536C-0.00338078 12.0117 -0.196518 9.98438 0.202848 8.03189C0.602213 6.0794 1.5758 4.29077 2.99881 2.89551L4.41885 4.31551C3.10153 5.58404 2.25861 7.26561 2.03048 9.08012C1.80235 10.8946 2.20275 12.7325 3.16507 14.2877C4.12738 15.8428 5.59348 17.0213 7.31912 17.6268C9.04476 18.2323 10.9258 18.2284 12.6488 17.6155L13.2788 19.5155C12.2471 19.8598 11.1665 20.0354 10.0788 20.0355Z",
    fill: "url(#paint1_linear_3151_4905)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.019043 2.01465H5.01904V7.01465L0.019043 2.01465Z",
    fill: "url(#paint2_linear_3151_4905)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.019 18.0146H15.019V13.0146L20.019 18.0146Z",
    fill: "url(#paint3_linear_3151_4905)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3151_4905",
    x1: 13.5763,
    y1: 18.7657,
    x2: 13.5763,
    y2: -2.22644,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292660"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2177,
    stopColor: "#5C2562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.656429,
    stopColor: "#9E2064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D91B5D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3151_4905",
    x1: 6.63942,
    y1: 21.6229,
    x2: 6.63942,
    y2: 0.673615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292660"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2177,
    stopColor: "#5C2562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.656429,
    stopColor: "#9E2064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D91B5D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3151_4905",
    x1: 2.51904,
    y1: 7.47761,
    x2: 2.51904,
    y2: 1.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292660"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2177,
    stopColor: "#5C2562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.656429,
    stopColor: "#9E2064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D91B5D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3151_4905",
    x1: 17.519,
    y1: 18.4776,
    x2: 17.519,
    y2: 12.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292660"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2177,
    stopColor: "#5C2562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.656429,
    stopColor: "#9E2064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D91B5D"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLatestRepaymentsActive);
export default __webpack_public_path__ + "static/media/latest-repayments-active.e2f9f109451581001fe168d462ab6638.svg";
export { ForwardRef as ReactComponent };